import type { ComponentType, SVGProps } from 'react';

import {
  SvgCog,
  SvgHome,
  SvgReports,
  SvgWallet,
} from '@actual-app/components/icons/v1';
import { SvgCalendar3 } from '@actual-app/components/icons/v2';

export type Destino = {
  /** Rótulo em português, passado por `t()` na hora de renderizar. */
  rotulo: string;
  rota: string;
  Icon:
    | ComponentType<SVGProps<SVGElement>>
    | ComponentType<SVGProps<SVGSVGElement>>;
  /**
   * @deprecated Ninguém mais usa. A fila de Pendências, único item que tinha
   * contador, saiu do menu em 22/09/2026 — um número vermelho no menu é a
   * "cara de trabalho" que o dono rejeitou. O campo fica no tipo porque
   * `PrimaryButtons.tsx` e `MobileNavTabs.tsx` ainda o leem; remover exigiria
   * mexer nos dois por nada.
   */
  temContador?: boolean;
};

/**
 * Os 5 destinos do menu, em 2 grupos — a MESMA lista para a barra lateral
 * (`sidebar/PrimaryButtons.tsx`) e para a barra de abas do celular
 * (`mobile/MobileNavTabs.tsx`).
 *
 * ⭐ Existe como módulo único de propósito: o dono usa os dois de verdade, e
 * antes as duas navegações eram listas separadas — o celular ficou meses com
 * o menu do Actual em inglês enquanto o desktop já tinha mudado.
 *
 * ⚠️ O que saiu daqui em 22/09/2026 (Pendências, Investimentos, Metas) NÃO
 * foi apagado: ver `finapp/telasOcultas.ts`, que lista cada uma com o motivo
 * e como religar.
 *
 * ⚠️ O atalho de **novo lançamento** não está aqui: ele é AÇÃO, não destino.
 * Aparece só na barra do celular (ver `MobileNavTabs.tsx`).
 */
export const MEU_MES: Destino[] = [
  { rotulo: 'Mês', rota: '/inicio', Icon: SvgHome },
];

export const MEU_DINHEIRO: Destino[] = [
  { rotulo: 'Médias', rota: '/medias', Icon: SvgReports },
  { rotulo: 'Compromissos', rota: '/compromissos', Icon: SvgCalendar3 },
  { rotulo: 'Patrimônio', rota: '/patrimonio', Icon: SvgWallet },
  { rotulo: 'Ajustes', rota: '/settings', Icon: SvgCog },
];

export const DESTINOS: Destino[] = [...MEU_MES, ...MEU_DINHEIRO];
